import styled from 'styled-components';

import {
  ClienteVendaRecebivelItem,
  ClienteVendaTotaisRecebiveis,
} from '../../../../../../../types/cliente-venda';
import { CollapsibleSection } from '../../produtos/sections/collapsible-section';
import { formatDate, formatPreco } from '../format';
import { Row } from './styles';

interface Props {
  recebiveis: ClienteVendaRecebivelItem[];
  totais: ClienteVendaTotaisRecebiveis;
  moedaSigla: string | null;
}

const Totals = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 12px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`;

const TotalChip = styled.div`
  background: ${({ theme }) => theme.colors.bgMuted};
  border-radius: ${({ theme }) => theme.radius.md};
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 2px;

  strong {
    font-size: 16px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.textPrimary};
    font-variant-numeric: tabular-nums;
  }
  small {
    font-size: 11px;
    color: ${({ theme }) => theme.colors.textMuted};
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 12px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.md};

  & + & {
    margin-top: 6px;
  }
`;

const Empty = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.textMuted};
`;

export const RecebiveisSection = ({ recebiveis, totais, moedaSigla }: Props) => (
  <CollapsibleSection
    title={`Recebíveis (${totais.quantidade})`}
    testId="venda-section-recebiveis"
  >
    {recebiveis.length === 0 ? (
      <Empty>Nenhum recebível gerado por esta venda.</Empty>
    ) : (
      <>
        <Totals>
          <TotalChip>
            <strong>{totais.quantidade}</strong>
            <small>Quantidade</small>
          </TotalChip>
          <TotalChip>
            <strong>{formatPreco(totais.somaValor, moedaSigla)}</strong>
            <small>Soma valor</small>
          </TotalChip>
          <TotalChip>
            <strong>
              {formatPreco(totais.somaValorAposBloqueio, moedaSigla)}
            </strong>
            <small>Após bloqueio</small>
          </TotalChip>
        </Totals>

        {recebiveis.map((r) => (
          <Item key={r.id}>
            <Row>
              <span>ID</span>
              <span>{r.id}</span>
            </Row>
            <Row>
              <span>Valor</span>
              <span>{formatPreco(r.valor, r.moedaSigla)}</span>
            </Row>
            <Row>
              <span>Status</span>
              <span>{r.statusDescricao ?? r.status ?? '—'}</span>
            </Row>
            <Row>
              <span>Tipo</span>
              <span>{r.tipoDescricao ?? r.tipo ?? '—'}</span>
            </Row>
            {r.releasedIn && (
              <Row>
                <span>Previsão</span>
                <span>{formatDate(r.releasedIn)}</span>
              </Row>
            )}
            {r.valorAposBloqueio != null && (
              <Row>
                <span>Após bloqueio</span>
                <span>{formatPreco(r.valorAposBloqueio, r.moedaSigla)}</span>
              </Row>
            )}
          </Item>
        ))}
      </>
    )}
  </CollapsibleSection>
);
